import { Component, Input, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { DataSourceItemsService } from '../../../../../data-source/data-source-items/services/data-source-items.service';
import { FiltersChannel } from '../../../../../filters/models/filters-channel.model';
import { Filters } from '../../../../../filters/models/filters.model';
import { IExportButtonTileDefinition } from '../../../../interfaces/tiles/definitions/export-button-tile-definition.interface';

@Component({
  standalone: false,
  selector: 'suvo-bi-export-button-tile',
  templateUrl: './export-button-tile.component.html',
  styleUrls: ['./export-button-tile.component.scss'],
})
export class ExportButtonTileComponent implements OnDestroy {
  @Input() tileInstance: IExportButtonTileDefinition;
  @Input() protected filtersChannel: FiltersChannel;

  isExporting = false;

  protected readonly unsubscribe$ = new Subject<void>();

  constructor(protected readonly dataSourceItemsService: DataSourceItemsService) {}

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  export() {
    if (this.isExporting) {
      return;
    }

    const dataSourceAlias = this.tileInstance.dataSource;
    const filters = this.filtersChannel.filters.getValue();
    const dateString = new Date().toLocaleDateString();
    const fileName = `${dataSourceAlias}_${filters.name}_${dateString}`.replace(/[^\w-_]/g, '');

    this.exportDataSourceItems(dataSourceAlias, filters, fileName);
  }

  protected exportDataSourceItems(dataSourceAlias: string, filters: Filters, fileName: string) {
    this.isExporting = true;

    this.dataSourceItemsService
      .getCsvString(
        dataSourceAlias,
        {
          filters,
        },
        {
          fileFormat: 'CSV',
          // maxItems: 500,
        },
      )
      .then((csvString) => {
        if (this.unsubscribe$.closed) {
          return;
        }

        const blob = new Blob([csvString], { type: 'text/csv' });
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = `${fileName}.csv`;
        link.click();

        this.isExporting = false;
      })
      .catch((error) => {
        console.error(error);
        this.isExporting = false;
      });
  }
}
